import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { Tc } from '../../../../core/_infrastructure/types/common';
import { EnumIdsTcTipoModulo } from '../../../../_importacion/solicitudes/types/enum';
import { PermisosAccionesImpresosIyIIIService } from '../permisosaccionesimpresosIyIII.service';
import { PermisosAccionesImpresosIyIIIViewModel } from '../permisosaccionesimpresosIyIII.types';

@Component({
    selector: 'app-permisosaccionesimpresosiyiii-wrapper-edit',
    templateUrl: './permisosaccionesimpresosiyiii-wrapper-edit.component.html',
})
export class PermisosAccionesImpresosIyIIIWrapperEditComponent extends ComponentBase implements OnInit {
    visibilitySpinner = false;
    permisoAccionImpresosIyIII: PermisosAccionesImpresosIyIIIViewModel;
    formGroup: FormGroup;

    messageErrorAlreadyExist = 'Ya existe este Permiso Acción para Impresos I y III';
    successMessage = 'Permiso Acción Impresos I y III guardado correctamente';
    listUrl = '/mantenimiento/permisos/permisosaccionesimpresosiyiii';

    activatedRoute$ = this.activatedRoute.paramMap.subscribe(params => {
        const id: any = params.get('id');
        if (id) {
            this.getPermisoAccionImpresosIyIII(id);
        }
    });

    listAcciones: Tc[];
    listPerfiles: Tc[];
    listEstadosImpresosIyIII: Tc[];

    idModuloImpresosIyIII = EnumIdsTcTipoModulo.ID_IMPRESOS_I_III;

    constructor(
        private fb: FormBuilder,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private permisosAccionesImpresosIyIIIService: PermisosAccionesImpresosIyIIIService,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit(): void {
        this.preparePresentation();

        this.permisosAccionesImpresosIyIIIService.getAcciones(this.idModuloImpresosIyIII).subscribe(params => {
            this.listAcciones = params;
        });

        this.permisosAccionesImpresosIyIIIService.getPerfiles().subscribe(params => {
            this.listPerfiles = params;
        });

        this.permisosAccionesImpresosIyIIIService.getEstadosImpresosIyIII().subscribe(params => {
            this.listEstadosImpresosIyIII = params;
        });
    }

    private preparePresentation(): void {
        this.buildForm();
    }

    private buildForm(): void {
        this.formGroup = this.fb.group({
            basic: this.fb.group({
                Id: [null],
                IdAccion: [null, Validators.required],
                IdPerfil: [null, Validators.required],
                IdEstadoImpresoIyIII: null,
                Edicion: true,
            }),
        });

        this.clearCustomValidator();

        this.form = this.formGroup;
    }

    private clearCustomValidator(): void {
        this.formGroup.valueChanges.subscribe(() => {
            try {
                this.removeCustomError('registry_duplicated', 'basic.IdAccion');
                this.formGroup.get('basic.IdAccion')?.updateValueAndValidity();
            } catch (e) {
                // Capturamos el error que se produce cuando carga el componente por primera vez, y el input IdAccion todavía no tiene el CustomError
            }
        });
    }

    private getPermisoAccionImpresosIyIII(id: number): void {
        this.permisosAccionesImpresosIyIIIService
            .getPermisoAccionImpresosIyIII(id)
            .pipe(
                tap((p: PermisosAccionesImpresosIyIIIViewModel) => {
                    this.permisoAccionImpresosIyIII = p;
                }),
                catchError(error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    this.formGroup.disable();
                    return of([]);
                }),
            )
            .subscribe();
    }

    onSave(): void {
        this.visibilitySpinner = true;
        const model = { ...this.formGroup.value.basic };

        this.permisosAccionesImpresosIyIIIService
            .savePermisoAccionImpresosIyIII(model)
            .pipe(
                tap(() => {
                    this.visibilitySpinner = false;
                    this.addSuccessMessage(this.successMessage);
                    this.onBack();
                }),
                catchError(error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    if (error?.error) {
                        error?.error.forEach((err: { key: string; field: string; message: string }) => {
                            if (err?.key === 'registry_duplicated') {
                                // Prefijo con basic., porque éste form en concreto tiene un grupo llamado así.
                                this.setCustomError(err?.key, 'basic.' + err?.field);
                                this.addErrorMessage('El permiso ya existe en base de datos');
                            } else {
                                this.addErrorMessage(err?.message);
                            }
                        });
                    }
                    return of([]);
                }),
            )
            .subscribe();
    }

    onBack(): void {
        this.router.navigate([this.listUrl]);
    }

    get formInvalid(): boolean {
        return !this.formGroup.valid || !this.formGroup.dirty || this.formGroup.pristine;
    }
}
